import {
  IMatch,
  IBaseMatchData,
  TMatchData,
  ICancelMatchData,
  IUpdateCheckoutDatePayload,
  IResponseShort,
  TReview,
  TUpdatedMatchPayload,
  TAggregatedMatchesResponse,
  THostActionExtrasPayload
} from "interfaces/interfaces";
import { ServiceApi } from "../utils/utilAmplify";
import { ServiceName } from "../config/amplify";
import query from "../utils/query";
import { MatchStatusEnum } from "../utils/constants";

class HostAPIClass {
  private readonly api: ServiceApi;

  constructor() {
    this.api = new ServiceApi(ServiceName.Protected);
  }

  getHostMatches(hostId: string): Promise<TMatchData[]> {
    return this.api.get(`matches/host-matches/${hostId}`);
  }
  getAggregatedMatches(
    userId: string,
    next_batch_token: string | null,
    from_match_status?: MatchStatusEnum,
    created_after?: Date | null
  ): Promise<TAggregatedMatchesResponse> {
    return this.api.get(
      `matches/host-matches-aggregated/${userId}?` +
        query.stringify({ next_batch_token, created_after, from_match_status })
    );
  }
  getMatch(
    studentId: string,
    hostId: string,
    houseId: string,
    options?: { showNotificationOnError?: boolean }
  ): Promise<IMatch> {
    return this.api
      .get(
        "matches/details?" +
          query.stringify({
            student_id: studentId,
            host_id: hostId,
            house_id: houseId
          }),
        options
      )
      .then((res) => res.data);
  }
  invite(payload: TUpdatedMatchPayload) {
    return this.api.post("matches/invite", payload);
  }
  cancelInvite(payload: IBaseMatchData) {
    return this.api.post("matches/cancel-invite", payload);
  }
  cancelMatch(payload: ICancelMatchData) {
    return this.api.post("matches/remove-tenant", payload);
  }
  updateOfferedDates(payload: TUpdatedMatchPayload) {
    return this.api.post("matches/update-offered-dates", payload);
  }
  updateCheckoutDate(
    payload: IUpdateCheckoutDatePayload
  ): Promise<IResponseShort> {
    return this.api.post("matches/change-checkout-date", payload);
  }
  setActions(payload: THostActionExtrasPayload): Promise<IResponseShort> {
    return this.api.post("matches/set-host-actions", payload);
  }
  toggleIsReviewApproved(
    hostId: string,
    payload: Pick<TReview, "approved" | "created_at">
  ): Promise<TReview> {
    return this.api.post(`reviews/${hostId}/toggle-approved`, payload);
  }
}

export const HostAPI = new HostAPIClass();
